import React from 'react';
import WordcupEvent from './firstworldcup/wordcupEvent';

export default function Actualites() {
  return (
    <>
      <WordcupEvent />
    </>
  );
}
